import React from "react";
import TicketsPage from "./TicketsPage";
import useTickets from "./useTickets";

function Tickets(props) {
  return <TicketsPage {...useTickets(props)} />;
}

export default Tickets;
